import { AppID } from '@playq/octopus-common';
import { QueryScriptRuntimeResponse } from '@playq/octopus2-scripts';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const scriptsQueryRuntimeKeys: unknown[] = ['scripts', 'service', 'queryRuntime'];

export const useScriptsRuntimeQuery = (
  app: AppID,
  options?: IUseQueryOptionsExtended<QueryScriptRuntimeResponse | undefined, GenericFailure | Error>
) => {
  const { mutate: _mutate, ...res } = useEitherQuery(
    scriptsQueryRuntimeKeys.concat(app?.toString()),
    () => services2.scriptsService.queryScriptsRuntime(app),
    { ...options, enabled: options?.enabled !== false && app instanceof AppID }
  );

  return {
    ...res,
  };
};
